export const OK = 'OK';
export const ERROR = 'ERROR';
export const TIMEOUT = 'TIMEOUT';
export const NOTLOGGEDIN = 'NOTLOGGEDIN';
// login
export const LOGIN_SUCCESS_MESSAGE = 'loginSuccessMessage';
export const PASSWORD_EXPIRED_MESSAGE = 'passwordExpiredMessage';
export const USER_UNVERIFIED_MESSAGE = 'userUnverifiedMessage';

// cda
export const UPLOAD_CDA_SUCCESS_MESSAGE = 'autoAddedCdaMessage';
export const GET_CDA_DOC_SUCCESS_MESSAGE = 'replyCdaMessage';
export const SAVE_CDA_SUCCESS_MESSAGE = 'clearedCdaMessage';
export const CDA_EXISTS_MESSAGE = 'cdaExists';
export const INVALID_FILE_FORMAT_MESSAGE = 'invalidCdaFileMessage';
// pdf
export const UPLOAD_PDF_SUCCESS_MESSAGE = 'pdfUploadedMessage';
// export const GET_PDF_DOC_SUCCESS_MESSAGE = 'replyPdfMessage';
// export const SAVE_PDF_SUCCESS_MESSAGE = '';
export const GET_GRABBED_IMAGE_SUCCESS_MESSAGE = 'pdfGrabbedMessage';
export const GET_GRABBED_PAGE_SUCCESS_MESSAGE = 'pdfPageGrabbedMessage';
export const SAVE_EXTRACTION_SUCCESS_MESSAGE = 'extractionSavedMessage';
export const GET_PREVIEW_SUCCESS_MESSAGE = 'getPreviewSuccess';
export const MISSING_CATEGORY_OR_PROCEDURE_MESSAGE = 'missingCategoryOrProcedure';

export const PING_SUCCESS_MESSAGE = 'pong';
export const SESSION_TIMEOUT_MESSAGE = 'sessionTimeoutMessage';
export const START_LOGIN_MESSAGE = 'startLoginMessage';

export const REGISTRATION_SUCCESS_MESSAGE = 'registrationSuccess';
export const REGISTRATION_FAILURE_MESSAGE = 'registrationFailure';

export const PASSWORD_RESET_SUCCESS_MESSAGE = 'passwordResetSuccess';
export const PASSWORD_RESET_FAILURE_MESSAGE = 'passwordResetFailure';

export const REQUEST_TOKEN_SUCCESS_MESSAGE = 'reuqestTokenSuccess';
export const REQUEST_TOKEN_FAILURE_MESSAGE = 'reuqestTokenFailure';

export const FORGOT_PASSWORD_SUCCESS_MESSAGE = 'requestForgotPasswordSuccess';

export const TOKEN_MISMATCH_MESSAGE = 'TOKEN_MISMATCH';
export const TOKEN_EXIPRED_MESSAGE = 'TOKEN_EXIPRED';
export const NO_SUCH_USER_MESSAGE = 'NO_SUCH_USER';
export const PASSWORD_IN_USE_MESSAGE = 'PASSWORD_IN_USE';
export const WRONG_PASSWORD_FORMAT_MESSAGE = 'WRONG_PASSWORD_FORMAT';